import { useAuth } from "@clerk/react"
import { useQuery } from "@tanstack/react-query"
import {
	CACHE_GC_TIME,
	CACHE_REFETCH,
	CACHE_STALE_TIME,
} from "@/config/constants"
import { useMarketplaceOrpc } from "@/integrations/orpc"
import type { ListModerationCasesInput } from "@/types/marketplace.types"

/** Prefix shared by every moderation read; every moderation write invalidates it. */
export const moderationQueryKey = ["marketplace-admin", "moderation"] as const

export function useModerationCases(
	input: ListModerationCasesInput,
	enabled = true,
) {
	const { client } = useMarketplaceOrpc()
	const { isSignedIn } = useAuth()

	return useQuery({
		queryKey: [...moderationQueryKey, "cases", input],
		queryFn: () => client.moderation.listCases(input),
		enabled: enabled && !!isSignedIn,
		staleTime: CACHE_STALE_TIME.ENTITY_TABLES,
		gcTime: CACHE_GC_TIME.ENTITY_TABLES,
		refetchOnWindowFocus: CACHE_REFETCH.ON_WINDOW_FOCUS,
	})
}
